"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _sanitizeUrl = _interopRequireDefault(require("./sanitizeUrl"));

var replaceRouteParams = function replaceRouteParams() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;
  var replaced = [];
  var inp = params || {};
  var result = (0, _sanitizeUrl.default)(path.replace(/\./g, '/').replace(/(:(\w+))/g, function (str, keyWithColon, key) {
    replaced.push(key);
    return encodeURIComponent(inp[key]);
  }));
  var nextParams = Object.keys(inp).reduce(function (np, key) {
    return (0, _extends2.default)({}, np, replaced.includes(key) ? {} : (0, _defineProperty2.default)({}, key, inp[key]));
  }, {});
  return [result, params ? nextParams : params];
};

var _default = replaceRouteParams;
exports.default = _default;